import PropTypes from "prop-types";
import React from "react";
import { Field } from "formik";
import FormInput2 from "../../components/FormInput/FormInput2";
import { RegionDropdown } from "react-country-region-selector";
import Button from "../../components/Button/Button";

export const SignUpForm2 = (props) => {
  const { setFieldValue, block2, page3, state } = props;

  return (
    <div className="form-1">
      <div className="form-input">
        <Field
          name="name"
          label="Company Name"
          type="text"
          placeholder="Enter Company Name"
          component={FormInput2}
        />
      </div>

      <div className="form-input">
        <Field
          name="address"
          label="Company Address"
          placeholder="Enter company address"
          component={FormInput2}
        />
      </div>

      <div className="form-dropdown2">
        <label htmlFor="" className="form-select-dropdown-label2">
          State
        </label>
        <Field
          render={() => (
            <>
              <div className="form-select-dropdown-group">
                <RegionDropdown
                  id="form2-input"
                  name="state"
                  classes="form-select-dropdown"
                  blankOptionLabel={`No country selected`}
                  defaultOptionLabel=""
                  country="Nigeria"
                  value={state}
                  onChange={(val) => setFieldValue("state", val, false)}
                />
              </div>
            </>
          )}
        />
      </div>

      <div className="form-input-button">
        <Button
          width="100%"
          height="45px"
          word={"Continue"}
          disabled={block2}
          onClick={page3}
          component={Button}
        />
      </div>
    </div>
  );
};

SignUpForm2.propTypes = {
  block2: PropTypes.any,
  page3: PropTypes.any,
  setFieldValue: PropTypes.func,
  state: PropTypes.any,
};

export default SignUpForm2;
